import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

const BoxButton = styled(Box)`
  line-height: 40px;
  display: inline-block;
  box-sizing: border-box;
  cursor: pointer;
  text-transform: none;
  transition-property: color, background-color, border-color, box-shadow;
  transition-duration: 0.1s;
  transition-timing-function: ease-in-out;
  height: 40px;
  color: rgb(46, 71, 135);
  outline: none;
  font: inherit inherit inherit inherit inherit inherit inherit;
  text-decoration: none;
  margin: 0px;
  background: transparent;
  overflow: visible;
  border-radius: 32px;
  padding: 0px 24px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(46, 71, 135);
  border-image: initial;
  &:hover {
        color: rgb(255, 255, 255);
        box-shadow: none;
        background: rgb(46, 71, 135);
  }
`
export default BoxButton
